<template>
  <PortalPageDesigner />
</template>

<script>
export default {
    components: {

    },
    data() {
        return {
        }
    }
}
</script>
